import React from 'react';
import PropTypes from 'prop-types';
import { Table, Drawer } from 'antd';

import { uniqueId } from '../../../../../../../data/config/utils';
import { IMG_EMPTY } from '../../../../../../../data/assets/img';

import ChooseMemberForm from '../choosememberform';
import InputItem from '../../../../../../../components/form/inputitem';
import TextAreaItem from '../../../../../../../components/form/textareaitem';
import CustomHeader from '../../../../../../../components/customheader';
import ProfileAvatar from '../../../../../../../components/profileavatar';
import TableCellAction from '../../../../../components/tablecellaction';
import ShowMessage from '../../../../../../../components/showmessage';
import ErrorBoundary from '../../../../../../../components/errorboundary';
import { MODULE_CONFIG } from "../../../../../../../data/config/urls";

class GroupForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.columns = this.getMemberTableColumns();
    this.state = {
      drawer_data: {
        title: "",
        show_choose_members: false,
      }
    }
  }

  getMemberTableColumns = () => {
    const columns = [
      {
        title: '',
        dataIndex: 'name',
        key: 'name',
        className: 'ori-l-pad-10',
        render: (text, group) => {
          return (
            <ProfileAvatar size="small" shape="square" container_class="ori-flex-ac" title={`${group.firstName} ${group.lastName}`} title_class="ori-font-xs" />
          );
        }
      },
      {
        title: '',
        dataIndex: 'email',
        key: 'email',
        sorter: (a, b) => a.email.localeCompare(b.email),
        defaultSortOrder: ['ascend']
      },
      {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        align: 'center',
        render: (text, record) => {
          return (
            <TableCellAction align_center show_delete delete_popconfirm_title="Are you sure remove this member?" handleDeleteClick={this.removeMemberFromGroup.bind(this, record)} />
          );
        }
      },
    ];
    return columns;
  };

  closeDrawer = () => {
    this.setState({
      drawer_data: {
        title: "",
        show_choose_members: false,
      }
    });
  };

  openDrawer = () => {
    this.setState({
      drawer_data: {
        title: "Select members",
        show_choose_members: true,
      }
    });
  };

  removeMemberFromGroup = member => {
    const { group, onChangeMembers } = this.props;
    if (member && member.email && group && group.agents) {
      const index = group.agents.findIndex(agent => agent.email === member.email);
      if (index !== -1) {
        const selected_members = [...group.agents.slice(0, index), ...group.agents.slice(index + 1)];
        onChangeMembers(selected_members);
      }
    }
  };

  handleOkClick = members => {
    this.props.onChangeMembers(members);
    this.closeDrawer();
  };

  renderMembersTable = () => {
    const { group, screen_width } = this.props;
    if (group.agents && group.agents.length > 0) {
      return (
        <Table className="ori-card-row-table ori-table-header-display-none" rowClassName="ori-bg-white" scroll={{ x: 450 }} size={screen_width < 768 ? "small" : "middle"} pagination={{ pageSize: MODULE_CONFIG.MEMBERS.MEMBERS_PER_PAGE_IN_EDIT_GROUP }} rowKey={uniqueId} columns={this.columns} dataSource={group.agents} />
      );
    }
    return (
      <ShowMessage img_src={IMG_EMPTY} height={120} width={120} message="There is no any member in this group. please click on add members button to add member in this group." />
    );
  };

  render() {
    const { group, agents, screen_width, onChangeName, onChangeDescription } = this.props;
    const { drawer_data } = this.state;

    return (
      <div className="ori-pad-15">
        <InputItem title="Name" placeholder="Enter group name" value={group.name} onChange={onChangeName} />
        <TextAreaItem title="Description" placeholder="write something about this group" min_rows={3} max_rows={3} value={group.description} onChange={onChangeDescription} />
        <div className="ori-t-pad-15">
          <CustomHeader title="Members" first_button_type="primary" first_button_text="+ Add members" onClickFirstButton={this.openDrawer} show_first_button />
          {this.renderMembersTable()}
        </div>
        <Drawer className="ori-drawer ori-drawer-title-primary ori-drawer-footer-pad ori-drawer-height-without-footer" width={screen_width < 768 ? screen_width : 450} title={drawer_data.title} visible={drawer_data.show_choose_members} placement="right" maskClosable={false} onClose={this.closeDrawer}>
          {
            drawer_data.show_choose_members &&
            <div className="ori-full-parent-height ori-overflow-y-auto ori-overflow-x-hidden">
              <ErrorBoundary onErrorCallback={this.closeDrawer}>
                <ChooseMemberForm agents={agents} default_selected_members={group.agents} handleCancelClick={this.closeDrawer} handleOkClick={this.handleOkClick} />
              </ErrorBoundary>
            </div>
          }
        </Drawer>
      </div>
    );
  }
}

GroupForm.propTypes = {
  group: PropTypes.object.isRequired,
  agents: PropTypes.array,
  screen_width: PropTypes.number,
  onChangeName: PropTypes.func,
  onChangeDescription: PropTypes.func,
  onChangeMembers: PropTypes.func
};

GroupForm.defaultProps = {
  group: {},
  agents: [],
  screen_width: 768
};

export default GroupForm;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/members/groups/components/groupform/index.js